import {
    ActionIcon,
    ActionIconProps,
    Menu,
    Tooltip,
    useComputedColorScheme,
    useMantineColorScheme,
} from "@mantine/core";
import { MdCheck, MdDarkMode, MdLightMode, MdOutlineBrightnessAuto } from "react-icons/md";

const options = [
    { value: "auto", label: "Auto", icon: <MdOutlineBrightnessAuto size={18} /> },
    { value: "light", label: "Ljust", icon: <MdLightMode size={18} /> },
    { value: "dark", label: "Mörkt", icon: <MdDarkMode size={18} /> },
] as const;

export function ThemeToggle({ size = "lg" }: { size?: ActionIconProps["size"] }) {
    const { colorScheme, setColorScheme } = useMantineColorScheme();
    const computedColorScheme = useComputedColorScheme("light", { getInitialValueInEffect: true });

    const triggerIcon =
        colorScheme === "auto" ? (
            <MdOutlineBrightnessAuto size={18} />
        ) : computedColorScheme === "dark" ? (
            <MdDarkMode size={18} />
        ) : (
            <MdLightMode size={18} />
        );

    return (
        <Menu shadow="md" width={180} position="bottom-end">
            <Menu.Target>
                <Tooltip label="Byt tema">
                    <ActionIcon aria-label="Byt tema" color="grape" radius="xl" size={size} variant="light">
                        {triggerIcon}
                    </ActionIcon>
                </Tooltip>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Label>Tema</Menu.Label>
                {options.map((option) => (
                    <Menu.Item
                        key={option.value}
                        leftSection={option.icon}
                        rightSection={colorScheme === option.value ? <MdCheck size={16} /> : null}
                        onClick={() => {
                            setColorScheme(option.value);
                        }}>
                        {option.label}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    );
}
